<template>
  <section>
    <Toolbar />
    <div class="ma-0 pa-0">
      <v-row justify="center" class="ma-0 pa-0 pt-5">
        <v-col cols="4" xs="4" sm="4" md="3" lg="3" xl="3" class="ma-0 pa-0">
          <v-img :src="ObtenerImgTerminacionActualizacion"></v-img>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-5">
        <v-col cols="10" class="ma-0 pa-0">
          <h2 class="texto-titulo text-center font-weight-bold">
            ¡Has actualizado tus documentos con éxito!
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-5">
        <v-col cols="10" class="ma-0 pa-0">
          <p class="text-body text-center grey--text text--darken-2">
            <span class="text-subtitle font-weight-bold black--text"
              >Estamos validando tus datos,</span
            >
            y en menos de
            <span class="text-subtitle font-weight-bold black--text"
              >24 horas</span
            >
            recibirás respuesta de tu solicitud.
          </p>
          <p
            class="text-body text-center black--text text-decoration-underline"
          >
            Te notificaremos vía SMS los siguientes pasos
          </p>
          <p class="text-body text-center grey--text text--darken-2">
            ¿Dudas y aclaraciones? Llama sin costo al
            <a href="tel:8003000268">800 3000 268</a>
          </p>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import Toolbar from '@/components/compartidos/Toolbar.vue'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'

export default {
  name: 'TerminacionActualizacion',
  components: {
    Toolbar,
  },
  mixins: [InsertaLogMixin],
  computed: {
    ObtenerImgTerminacionActualizacion() {
      // return require(this.urlImgTerminacion)
      return require('@/assets/images/stopwatch.png')
    },
  },
  mounted() {
    this.InsertaLog()
  },
  created() {
    this.$store.commit('ESTABLECER_LAYOUT', 'Layout')
  },
}
</script>

<style>
.img-terminacion {
  width: 100px;
  height: 100px;
}
body {
  margin: 0;
}
</style>
